import { createContext } from 'react';

export const RefetchLateral = createContext({
  refetchLateral: () => {},
  refetchTabs: () => {},
  campaignId: '',
  influencerId: '',
  brandId: '',
});
